import React from "react";
import { axiosget } from "../../helpers/httprequest";
import Loader from "../../components/Loader";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import ErrorResponse from "../../components/ErrorResponse";

const Print = () => {
  const { id } = useParams();

  const { data, isLoading, error } = useQuery({
    queryKey: ["finalPrintInformation"],
    queryFn: async () => {
      const req = await axiosget(`ms_application_fee/receipt/${id}`);
      return req?.data;
    },
  });

  if (!isLoading) {
    // setTimeout(() => window.print(), 500);
  }

  return (
    <div className="container-scroller">
      {isLoading ? (
        <Loader />
      ) : (
        <div className="card">
          {error ? (
            <ErrorResponse message={error} type={"danger"} />
          ) : (
            <div className="card-body">
              <div className="container-fluid">
                <div className="p-5" id="printDocument">
                  <div className="row">
                    <div className="col-md-12 text-center">
                      <div className="d-flex justify-content-between">
                        <img src="../images/logo.png" alt="logo" style={{ maxWidth: 150 }} />
                        <div className="text-center">
                          <div className="text-uppercase" style={{ fontWeight: "bold", fontSize: 20 }}>Kebbi State Polytechnic Dakingari </div>
                          <div style={{ fontWeight: "bold", fontSize: 18 }}>Dakingari, Kebbi STATE</div>
                          <div>ADMISSION APPLICATION SLIP</div>
                          <div>{new Date().toISOString()}</div>
                        </div>
                      </div>
                    </div>
                    <hr className="mb-3 mt-3 border border-black" />
                    <div className="col-md-12 text-center">
                      <img src={data?.bio?.photo?.link} className="br-10" style={{ maxWidth: "320px", maxHeight: "250px" }} alt="passport" />
                    </div>
                    <div className="col-md-12">
                      <div className="row my-2 bordered_bottom">
                        <div className="col-md-4 text-muted ">Application ID</div>
                        <div className="col-md-7 ">{data?.find?.application?.code}</div>
                      </div>
                      <div className="row my-2 bordered_bottom">
                        <div className="col-md-4 text-muted ">Programme Details</div>
                        <div className="col-md-7 ">
                          {data?.find?.programme?.code} :: {data?.find?.programme?.name}
                        </div>
                      </div>
                      <div className="row my-2 bordered_bottom">
                        <div className="col-md-4 text-muted">School Semester</div>
                        <div className="col-md-8">
                          {data?.find?.application?.session?.code} :: {data?.find?.application?.session?.name}
                        </div>
                      </div>
                      <div className="row my-2 bordered_bottom">
                        <div className="col-md-4 text-muted">Full Name</div>
                        <div className="col-md-7">
                          {data?.bio?.firstname} {data?.bio?.middlename} {data?.bio?.lastname}
                        </div>
                      </div>
                      <div className="row my-2 bordered_bottom">
                        <div className="col-md-4 text-muted">Date of Birth</div>
                        <div className="col-md-7">{new Date(data?.bio?.dateofbirth).toLocaleDateString()}</div>
                      </div>

                      <div className="row my-2 bordered_bottom">
                        <div className="col-md-4 text-muted">Phont Number</div>
                        <div className="col-md-8">{data?.bio?.phonenumber}</div>
                      </div>
                      <div className="row my-2 bordered_bottom">
                        <div className="col-md-4 text-muted">Email Address</div>
                        <div className="col-md-7">{data?.bio?.emailaddress}</div>
                      </div>
                      <div className="row my-2 bordered_bottom">
                        <div className="col-md-4 text-muted">Gender</div>
                        <div className="col-md-7">{data?.bio?.gender}</div>
                      </div>
                      <div className="row my-2 bordered_bottom">
                        <div className="col-md-4 text-muted">Remita Payment Reference</div>
                        <div className="col-md-7">{data?.find?.trxcode}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Print;
